import React from "react";

import SrrRowBase from "./SrrRowBase";

const TOMonthOfControlFriendOrFoeByCarFamily = ({ row, items, group }) => {
  const dealerArr = [
    "DealerName",
    "INN",
    "ent_id",
    "subject",
    "FO",
    "city",
    "family",
  ];
  const cityArr = ["city", "subject", "FO", "family"];
  const foArr = ["FO", "family"];
  const regionArr = ["subject", "FO", "family"];
  const countryArr = ["family"];
  let optionsTable = [];

  switch (group["group"]) {
    case "dealer":
      optionsTable = dealerArr.map((el) => row[el]);
      break;
    case "city":
      optionsTable = cityArr.map((el) => row[el]);
      break;
    case "fo":
      optionsTable = foArr.map((el) => row[el]);
      break;
    case "region":
      optionsTable = regionArr.map((el) => row[el]);
      break;
    case "country":
      optionsTable = countryArr.map((el) => row[el]);
      break;
  }

  const renderItem = Object.keys(row)
    .map((key) => {
      if (group["arrTO"].includes(key)) {
        const toCarsForeign = row[key]?.carsForeign || [];
        //
        let serviceCountGeneral = row[key]?.cars.length + toCarsForeign.length;
        let serviceCountMine = row[key]?.cars.length;
        let serviceCountStranger = toCarsForeign.length;
        let percentGeneral = 0;
        let percentMine = 0;
        let percentStranger = 0;
        if (row[key]?.saleCount > 0 && serviceCountGeneral > 0) {
          percentGeneral = (serviceCountGeneral / row[key]?.saleCount) * 100;
        }
        if (row[key]?.saleCount > 0 && serviceCountMine > 0) {
          percentMine = (serviceCountMine / row[key]?.saleCount) * 100;
        }
        if (row[key]?.saleCount > 0 && serviceCountStranger > 0) {
          percentStranger = (serviceCountStranger / row[key]?.saleCount) * 100;
        }

        return [
          row[key]?.saleCount,
          serviceCountGeneral,
          percentGeneral.toFixed(2),
          serviceCountMine,
          percentMine.toFixed(2),
          serviceCountStranger,
          percentStranger.toFixed(2),
        ];
      }
    })
    .filter((value) => value !== undefined);

  return <SrrRowBase leadingCells={optionsTable} cells={renderItem} />;
};

export default TOMonthOfControlFriendOrFoeByCarFamily;
